/**
 * Singleton BroadcastChannel for cross-tab state synchronization.
 *
 * All tabs share one named channel ("auth_channel"). Importing this module
 * from any file always returns the same channel instance within that tab, so
 * there is never more than one listener registered per tab.
 *
 * Gracefully returns null in environments that don't support the API
 * (SSR, older browsers) so callers can guard with a simple null-check.
 */
const broadcastChannel =
  typeof window !== "undefined" && "BroadcastChannel" in window
    ? new BroadcastChannel("auth_channel")
    : null;

export default broadcastChannel;
